import { render } from "./PinUp.vue?vue&type=template&id=3245053a&scoped=true"
import script from "./PinUp.vue?vue&type=script&lang=js"
export * from "./PinUp.vue?vue&type=script&lang=js"

import "./PinUp.vue?vue&type=style&index=0&id=3245053a&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3245053a"]])

export default __exports__